import axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";
import React, { useEffect, useState } from "react";
import "../../../pages/css/BillingGroupPricing/BillingGroupPricing.css"
import { Checkbox } from "@fluentui/react";
import { Button, Form, Table } from "react-bootstrap";
import { qsStringify } from "src/utilities/helper";
import Select from "react-select"
import Loader from "src/components/common/Loader";
import logger from '../../../utilities/logging';

interface utilityProps {
    UtilityID: number
    UtilityName: string
    ContractID: number
    ContractExpirationDate: string
}
interface profitCenterprops {
    id: number
    text: string
}
interface responsesProps {
    ResponseID: number
    ResponseText: string
    ResponseCode: string
    ResponseUnitType: string
}
interface AddAvailableResponseProps {
    Utilities: utilityProps[]
    billinggroupid: number
    close: Function
    refresh: Function
}
function AddAvailableResponse(props: AddAvailableResponseProps) {
    const [responses, setResponses] = useState<responsesProps[]>([{ ResponseID: 0, ResponseText: "", ResponseCode: "", ResponseUnitType: "" }])
    const billingUtilities = props.Utilities
    const billinggroupid = props.billinggroupid
    const close = props.close
    const refresh = props.refresh
    const [utilityID, setUtilityId] = useState(billingUtilities[0].UtilityID)
    const [selectedRow, setSelectedRow] = useState<number>(-99)
    const [responseDesc, setResponseDesc] = useState("")
    const [quantityRequired, setQuantityRequired] = useState(false)
    const [footageRequired, setFootageRequired] = useState(false)
    const [timeRequired, setTimeRequired] = useState(false)
    const [quantityWarningThreshold, setQuantityWarningThreshold] = useState<number | undefined>(undefined)
    const [profitCenters, setProfitCenters] = useState<profitCenterprops[]>([{ id: 0, text: "" }])
    const [profitCenterID, setProfitCenterID] = useState(0)
    const [filter, setFilter] = useState<keyof responsesProps>("ResponseID")
    const [acdc, setACDC] = useState(1)
    const [adminOnly, setAdminOnly] = useState(true)
    const [isLoading, setIsLoading] = useState(false)

    // New states for the additional fields for task 3238
    const [afterHoursOnly, setAfterHoursOnly] = useState(false)
    const [afterHoursWeekends, setAfterHoursWeekends] = useState(false)
    const [afterHoursHolidays, setAfterHoursHolidays] = useState(false)

    const GetResponses = () => {
        axios.get(process.env.REACT_APP_API_URL + `/api/css/nonActive/locator/${utilityID}/${profitCenterID}`, AxiosConfig.configValue("min"))
            .then((res) => (setResponses(res.data)))
    }
    const GetProfitCenters = () => {
        axios.get(process.env.REACT_APP_API_URL + `/api/css/billing/ProfitCenter/${billinggroupid}`, AxiosConfig.configValue("min"))
            //r-18-lint-cn
            //eslint-disable-next-line
            .then((res) => (setProfitCenters(res.data), setProfitCenterID(res.data[0].id)))
    }
    const insertAvailableResponse = () => {
        if (selectedRow !== -99) {
            axios.post(process.env.REACT_APP_API_URL + '/api/css/AddAvailableResponse', qsStringify({
                UtilityID: utilityID,
                ProfitCenterID: profitCenterID,
                ResponseID: selectedRow,
                ResponseHelp: responseDesc,
                QuantityRequired: quantityRequired,
                FootageRequired: footageRequired,
                TimeRequired: timeRequired,
                QuantityWarningThreshold: quantityWarningThreshold,
                AdminOnly: adminOnly,
                AfterHoursOnly: afterHoursOnly,               // New field for task 3238
                AfterHoursWeekends: afterHoursWeekends,       // New field for task 3238
                AfterHoursHolidays: afterHoursHolidays        // New field for task 3238
            }), AxiosConfig.configValue())
                //r-18-lint-cn
                //eslint-disable-next-line
                .then((res) => {
                    AxiosConfig.checkResponse(
                        res,
                        { alertOnSuccess: true, successMessage: "Added Available Response", showSnackbar: true, snackBar: { manual: true } }
                    )
                    if (res.data.error == undefined) {
                        setSelectedRow(-99)
                    }
                    refresh()
                    GetResponses()
                })
                .finally(() => setIsLoading(false))
                .catch((error) => {
                    alert("There was an error Inserting and Available Response");
                    //console.log(error);
                    logger.Error({
                        EventMessage: `BillingGroupPricing -> InsertAvailableResponse -> Error : ${JSON.stringify(error)}`,
                        EventCategory: "httprequest"
                    });
                    AxiosConfig.handleError(error);
                })
        }
        else {
            alert("Invalid Response")
            setIsLoading(false)
        }
    }
    useEffect(() => {
        if (profitCenterID !== 0) {
            GetResponses()
        }
        setSelectedRow(-99)
        //r-18-lint-cn
        //eslint-disable-next-line
    }, [utilityID, profitCenterID])
    useEffect(() => {
        GetProfitCenters()
        //r-18-lint-cn
        //eslint-disable-next-line
    }, [])

    const handleAfterHoursOnlyClick = () => {
        // Toggle the afterHoursOnly state
        setAfterHoursOnly(!afterHoursOnly);

        // If afterHoursOnly is being unchecked, also uncheck weekends and holidays
        if (afterHoursOnly) {
            setAfterHoursWeekends(false);
            setAfterHoursHolidays(false);
        }
    };


    return (
        <div className="locatorResponseModal">
            <div className="locatorModalSelect">
                <div>
                    <span>
                        Utility:
                    </span>
                    <div>
                        <Select
                            id="select"
                            onChange={(e: any) => (setUtilityId(e.value))}
                            options={billingUtilities.map((x) => ({ value: x.UtilityID, label: x.UtilityName }))}
                            value={{ label: billingUtilities.find(x => x.UtilityID === utilityID)?.UtilityName, value: utilityID }}
                        />
                    </div>
                </div>
                <div>
                    <span>
                        Profit Center:
                    </span>
                    <div>
                        <Select
                            id="select"
                            onChange={(e: any) => setProfitCenterID(e.value)}
                            options={profitCenters.map((x) => ({ value: x.id, label: x.text }))}
                            value={{ label: profitCenters.find((x) => x.id === profitCenterID)?.text, value: profitCenterID }}
                        />
                    </div>
                </div>
            </div>
            <div className="addAvailableResponseTable">
                {
                    isLoading ?
                        <Loader title="Loading Responses..." />
                        :
                        <Table>
                            <thead>
                                <tr>
                                    <th onClick={() => filter === "ResponseID" ? setACDC(-1 * acdc) : (setFilter("ResponseID"), setACDC(1))}>
                                        Response ID
                                        <span className="material-icons">unfold_more</span>
                                    </th>
                                    <th onClick={() => filter === "ResponseText" ? setACDC(-1 * acdc) : (setFilter("ResponseText"), setACDC(1))}>
                                        Response Text
                                        <span className="material-icons">unfold_more</span>
                                    </th>
                                    <th onClick={() => filter === "ResponseCode" ? setACDC(-1 * acdc) : (setFilter("ResponseCode"), setACDC(1))}>
                                        Response Code
                                        <span className="material-icons">unfold_more</span>
                                    </th>
                                    <th onClick={() => filter === "ResponseUnitType" ? setACDC(-1 * acdc) : (setFilter("ResponseUnitType"), setACDC(1))}>
                                        Response Unit Type
                                        <span className="material-icons">unfold_more</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {responses.sort((a, b) => a[filter] > b[filter] ? 1 * acdc : a[filter] === b[filter] ? 0 : -1 * acdc).map((x) =>
                                    <tr key={x.ResponseID} onClick={() => setSelectedRow(x.ResponseID)} className={x.ResponseID === selectedRow ? "rowHighlight" : ""}>
                                        <td>{x.ResponseID}</td>
                                        <td>{x.ResponseText}</td>
                                        <td>{x.ResponseCode}</td>
                                        <td>{x.ResponseUnitType}</td>
                                    </tr>)}
                            </tbody>
                        </Table>
                }
            </div>
            <div className="locatorDescriptionText">
                <div>
                    <span>Description:</span>
                </div>
                <Form.Control value={responseDesc} onChange={(e) => setResponseDesc(e.target.value)} as="textarea" />
            </div>
            <div className="locatorDescriptionInput">
                <Checkbox checked={quantityRequired} onChange={() => setQuantityRequired(!quantityRequired)} label="Quantity Required" />
                <Checkbox checked={footageRequired} onChange={() => setFootageRequired(!footageRequired)} label="Footage Required" />
                <Checkbox checked={timeRequired} onChange={() => setTimeRequired(!timeRequired)} label="Time Required" />
                <Checkbox checked={!adminOnly} onChange={() => setAdminOnly(!adminOnly)} label="Admin Only" />
                {/* New checkboxes for the after hours fields for task 3238 */}
                <Checkbox
                    checked={afterHoursOnly}
                    onChange={handleAfterHoursOnlyClick}
                    label="After Hours Only"
                />
                <Checkbox
                    disabled={!afterHoursOnly}
                    checked={afterHoursWeekends && afterHoursOnly}
                    onChange={() => setAfterHoursWeekends(!afterHoursWeekends)}
                    label="After Hours Weekends"
                />
                <Checkbox
                    disabled={!afterHoursOnly}
                    checked={afterHoursHolidays && afterHoursOnly}
                    onChange={() => setAfterHoursHolidays(!afterHoursHolidays)}
                    label="After Hours Holidays"
                />
            </div>
            <div className="locatorNumberInput">
                <div>
                    <span>Quantity Warning Threshold:</span>
                </div>
                <Form.Control type="number" defaultValue={quantityWarningThreshold} onChange={(e) => setQuantityWarningThreshold(Number(e.target.value))} />
            </div>
            <div className="responseModalButtons">
                <Button variant={selectedRow === -99 ? "outline-dark" : "primary"} disabled={selectedRow === -99} onClick={() => (insertAvailableResponse(), setIsLoading(true))}>Add</Button>
                <Button variant="secondary" onClick={() => close()}>Close</Button>
            </div>
        </div>
    )
}

export default AddAvailableResponse